import { render } from "./GzOldList.vue?vue&type=template&id=186f8b9a&scoped=true"
import script from "./GzOldList.vue?vue&type=script&lang=js"
export * from "./GzOldList.vue?vue&type=script&lang=js"

import "./GzOldList.vue?vue&type=style&index=0&id=186f8b9a&scoped=true&lang=less"

import exportComponent from "C:\\Users\\徐永哲\\Desktop\\银商北分远程办公系统\\wx-wl_full_II\\fxwl\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-186f8b9a"]])

export default __exports__